import { TextInput } from 'flowbite-react';
import { ReactNode } from 'react';

export interface InputProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  type?: 'text' | 'password' | 'email' | 'tel';
  disabled?: boolean;
  className?: string;
  rightIcon?: ReactNode;
  leftIcon?: ReactNode;
}

export const Input: React.FC<InputProps> = ({
  placeholder,
  value,
  onChange,
  type = 'text',
  disabled = false,
  className = '',
  rightIcon,
  leftIcon,
}) => {
  return (
    <div className={`relative ${className}`}>
      {leftIcon && (
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
          {leftIcon}
        </div>
      )}
      <TextInput
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        className={`w-full ${leftIcon ? 'pl-10' : ''} ${
          rightIcon ? 'pr-10' : ''
        }`}
      />
      {rightIcon && (
        <div className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer">
          {rightIcon}
        </div>
      )}
    </div>
  );
};
